import { render, staticRenderFns } from "./MemberSelector.vue?vue&type=template&id=64925a1e&"
import script from "./MemberSelector.vue?vue&type=script&lang=js&"
export * from "./MemberSelector.vue?vue&type=script&lang=js&"
import style0 from "./MemberSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports